import { render, staticRenderFns } from "./Factory.vue?vue&type=template&id=66679658"
import script from "./Factory.vue?vue&type=script&lang=js"
export * from "./Factory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports